import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import {updateValueInJson, hideModalPageClass, showModalPageClass, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import ModalPaginas from '../../Partials/ModalPaginas';

export default class EditarHerramientaPyme extends Component {

    constructor(props) {

        super(props);

        this.state = {
            key: 0,
            tituloLongitud:0,
            descripcionLongitud:0,
            resource: {
                hpym_Titulo:"",
                hpym_Descripcion:"",
                hpym_Enlace:"",
                sect_Id:0,
                pweb_Id:0,
                chan_Id:0,
                hpym_Destacar:false,
                hpym_Orden:0,
                hpym_Activo:true
            },
            Validacion: {
                hpym_Titulo: {
                    Error: false,
                },
                hpym_Descripcion: {
                    Error: false,
                },
                hpym_Enlace: {
                    Error: false,
                },
                sect_Id: {
                    Error: false,
                },
                pweb_Id: {
                    Error: false,
                },
                chan_Id: {
                    Error: false,
                },
                hpym_Destacar: {
                    Error: false,
                },
                hpym_Orden: {
                    Error: false,
                }
            },
            categorias: [],
            sectores: [],
            perfiles: [],
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);
      }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        resource.hpym_Enlace = urlSeleccionada;

        this.setState({resource:resource});

        hideModalPageClass();
    }

    componentDidMount()
    {

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/herramientas-pyme";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);

        const url = `${API_URL}HerramientaPymesUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    categorias: data.result.categorias,
                    sectores: data.result.sectores,
                    perfiles: data.result.perfiles
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    componentWillMount(){

        var key = this.props.match.params.id;
        const url = `${API_URL}HerramientaPymesUX/Seleccionar/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            this.setState({ resource: data.result, response: data, error: data.Error });

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });

    }

    handleClickCancel(e) {
        const {history: {push}} = this.props;
        push('/herramientas-pyme');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.hpym_Titulo == '') {
            newState.Validacion.hpym_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.hpym_Descripcion == '') {
            newState.Validacion.hpym_Descripcion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.hpym_Enlace == '' || !esUrl(newState.resource.hpym_Enlace))
		{
            newState.Validacion.hpym_Enlace = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.chan_Id == 0) {
            newState.Validacion.chan_Id = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.hpym_Orden == '') {
            newState.Validacion.hpym_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}HerramientaPymesUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'hpym_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);

                setTimeout(() => {
                    this.handleClickCancel();
                }, 1000);

                setTimeout(() => {
                    this.setState({added:false});
                }, 5000);

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'hpym_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'hpym_Descripcion'){
            descripcionLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Herramienta Pyme</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Herramienta Pyme
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='hpym_Titulo' value={this.state.resource.hpym_Titulo} maxLength={35} className={this.state.Validacion.hpym_Titulo.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={35}>{this.state.tituloLongitud}/35</span>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Descripción" name='hpym_Descripcion' value={this.state.resource.hpym_Descripcion} maxLength={250} className={this.state.Validacion.hpym_Descripcion.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={250}>{this.state.descripcionLongitud}/250</span>
                    </div>

                    <div className="txtFile x-1">
                        <span className="openLink" onClick={() => showModalPageClass()}/>
                        <input type="text" placeholder="Enlace" name='hpym_Enlace' value={this.state.resource.hpym_Enlace} className={this.state.Validacion.hpym_Enlace.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <select name='chan_Id' id='chan_Id' onChange={this.handleInputChange} className={this.state.Validacion.chan_Id.Error ? "error" : ""}>
                            <option value="0">Seleccionar Categoría</option>
                            {
                                this.state.categorias.length > 0 ?
                                this.state.categorias.map((categoria) => (
                                    <option value={categoria.id} selected={this.state.resource.chan_Id == categoria.id ? true : false}>{categoria.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>
                    </div>

                    <div className="txtFile x-1">
                        <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Sector</option>
                            {
                                this.state.sectores.length > 0 ?
                                this.state.sectores.map((sector) => (
                                    <option value={sector.id} selected={(this.state.resource.sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>
                    </div>

                    <div className="txtFile x-1">
                        <select name='pweb_Id' id='pweb_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Perfil</option>
                            {
                                this.state.perfiles.length > 0 ?
                                this.state.perfiles.map((perfil) => (
                                    <option value={perfil.id} selected={(this.state.resource.pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>
                    </div>

                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='hpym_Orden' value={this.state.resource.hpym_Orden} maxLength={2} className={this.state.Validacion.hpym_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalPaginas class={""} callback={this.getResponse.bind(this)} />
            </div>
        )
    }
}
